import Vue from 'vue'
import separator from '@/components/Form/separator'
import headerTitle from '@/components/Form/header-title'
import containerFluid from '@/components/Form/container-fluid'
Vue.component('app-separator', separator)
Vue.component('header-title', headerTitle)
Vue.component('container-fluid', containerFluid)
